import { wideGamutColor } from './utils/wideGamutColor'

/**
 * Older set of core colors as defined in the Gem design system
 * See: https://app.abstract.com/projects/d86bdd30-fdac-11e8-80b2-d1a32618cd34/branches/main/collections/16464d6d-16fc-4d1a-978c-97c559276072
 *
 * @deprecated Use CSS Variables when possible, or GemColors as a last resort.
 * @example
 *  // Use this instead
 *  const style = { color: `var(${ThemedColors.Primary1})` }
 */
export const DeprecatedGemColors = {
  // PRIMARY
  BL200: wideGamutColor('#2A70EA'),
  BD000: wideGamutColor('#263042'),
  BD200: wideGamutColor('#3D83FF'),

  // SECONDARY
  GL100: wideGamutColor('#00A148'),
  RL100: wideGamutColor('#D64040'),

  // TEXT
  LMBLACK: wideGamutColor('#152026'),
  LMGRAY: wideGamutColor('#6D7175'),
  LMRED: wideGamutColor('#C93E44'),
  LMBLUE: wideGamutColor('#266ADB'),

  DMBLACK: wideGamutColor('#152026'),
  DMGRAY: wideGamutColor('#959799'),
  DMRED: wideGamutColor('#FF5E65'),
  DMBLUE: wideGamutColor('#5A96FA'),
} as const
